import { useEffect, useMemo, useState } from 'react';
import { Session, initialSessionState, socketUrl, type SessionState } from './Session';
import { takeCredential, type SeatCredential } from './fragment';

function safeSessionStorage(): Storage | undefined {
  try { return window.sessionStorage; } catch { return undefined; }
}

export function useSession(spectator = false, credential?: SeatCredential | null, paused = false): { session: Session; state: SessionState } {
  const session = useMemo(() => new Session(socketUrl(window.location), spectator ? null : credential === undefined ? takeCredential(window.location, window.history, safeSessionStorage()) : credential), [spectator, credential]);
  const [state, setState] = useState<SessionState>(initialSessionState);
  session.readOnly = paused;
  useEffect(() => {
    const unsubscribe = session.subscribe(setState);
    session.start();
    return () => { unsubscribe(); session.stop(); };
  }, [session]);
  return { session, state };
}
